import { popupState, popupData } from 'core';
import { IPopupState } from 'core/state';
import { hideOtherPopUps } from './hideOtherPopUps';
import { IPopupStateOperations } from './PopupHooks';

export const getPopupStateOperations = (
  state = popupState,
): IPopupStateOperations => {
  const setPopup = <T>(
    isOpen: boolean,
    popup: keyof IPopupState,
    data: T | null,
  ) => {
    // 🔴 Данные — ДО открытия. Внутри обработчика клика React 17 склеивает
    // оба обновления, и порядок не виден. Но после `await` (окно открывают,
    // дождавшись запроса — ТЗ 0087, «Забрать из Notion») склейки нет: каждое
    // обновление рисуется сразу, и окно, открытое раньше данных, падало на
    // `const { title } = undefined` — белым экраном всего ERP.
    if (data) {
      popupData({ ...popupData(), [popup]: data });
    }
    state({ ...hideOtherPopUps(), [popup]: isOpen });
  };

  const showPopup = <T>(popup: keyof IPopupState, data: T | null = null) =>
    setPopup<T>(true, popup, data);
  const hidePopup = <T>(popup: keyof IPopupState) => {
    setPopup<T>(false, popup, null);
    popupData({ ...popupData(), [popup]: undefined });
  };

  return { showPopup, hidePopup };
};
